import { Component, computed, effect, Inject, OnInit, signal, WritableSignal } from '@angular/core';
import { AvailableColumn } from '@app/common/models';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ColumnTypes, NumberRangeValue, NumberValue, TextValue, DateRangeValue, BoolValue, ListValue, DateValue, DynListValue, DynListOption, ItemValueModel, ItemValueListTypeTable, EANValue } from '@app/common/models/columnBase.model';
import { select, Store } from '@ngrx/store';
import { filter, Observable, of, take } from 'rxjs';
import { ISettingChildrenValue, ISettingValue, SettingValueEnum } from '@app/common/models/setting.models';
import { CommonCheckService, CommonDataService, NovitaetenLookupService } from 'FoxxyLib';
import { GetSettingsChildrenAction, GetSettingsStateAction } from 'FoxxyLib';
import { GetStaticListValuesAction, selectStaticUsedlistValues, UpdateStaticListValuesAction } from '../store';
import { SelectChangeEvent } from 'primeng/select';


@Component({
    selector: 'app-editavailablecolumn-view',
    templateUrl: 'editAvailableColumn.dialog.component.html',
    styleUrls: ['./dialogs.component.scss'],
    standalone: false,
    providers: [CommonDataService]
})

export class EditAvailableColumnDialogComponent implements OnInit {

  availableColumnToView: AvailableColumn;
  numberRangeValue: NumberRangeValue = { numberrangestart: 0, numberrangeend: 0 };
  dateRangeValue: DateRangeValue = { daterangestart: new Date, daterangeend: new Date };
  numberValue: NumberValue = { maxdigits: 0, maxdecimals: 0, isnumberonly: false , requiredcolumnvalue: null , minNumber: 0, maxNumber: 0, notcolumnvalue: null};
  textValue: TextValue = { maxlength: 120, validregex: null, minlength: 0 , requiredcolumnvalue: null, notcolumnvalue: null };
  eanValue: EANValue = { value: undefined };
  listValue: ListValue = { valuelist: [] };
  dynListOptions: DynListValue[] = [];
  dynmlistValue: DynListValue =  null;

  checkBoxValue: BoolValue = { value: null, requiredcolumnvalue: null , notcolumnvalue: null };
  dateValue: DateValue = { value: null };

  colTypeOptions: { label: string, value: number }[] = [];
  colEnum: any;

  hint: WritableSignal<string> = signal(null);

  settingValueList: WritableSignal<ISettingValue[]> = signal([]);
  selecteddbMapping: WritableSignal<ISettingValue> = signal(null);
  selectedChildren: WritableSignal<{ [key: string]: ISettingChildrenValue[] }> = signal({});
  selectStaticUsedlistValues$ : Observable<{[key: number]: ItemValueModel[]}> = of({});
  moebeldynmlistValue: DynListValue;

  referenceColumnValuesDynListOptions: WritableSignal<ItemValueModel[]> = signal([]);
  referenceColumnValueDynList: string;
  referenceNOTColumnValueDynList: string[];

  referenceColumnValueNumberListOptions: WritableSignal<ItemValueModel[]> = signal([]);


  allColumns: AvailableColumn[];


  constructor(
    private store: Store<any>,
    private validateService: CommonCheckService,
    private commondataService : CommonDataService,
    @Inject(DynamicDialogRef) public ref: DynamicDialogRef,
    @Inject(DynamicDialogConfig) public config: DynamicDialogConfig
  ) {

    this.selectStaticUsedlistValues$ = this.store.pipe(select(selectStaticUsedlistValues));
    effect(() => {
      const mapp = this.selecteddbMapping();
      if ( mapp &&  mapp.isActive == 0)
      {
        this.hint.set('Das Db-Mapping wurde nicht gefunden. ');
      }
    } );

  }


  referenceNOTColumnValueNumberListOptions = computed(()=>
  {
      const gesetzt = this.referenceColumnValueDynList ?? this.numberValue?.requiredcolumnvalue ??
      this.checkBoxValue?.requiredcolumnvalue ?? this.textValue?.requiredcolumnvalue; ;
      return this.referenceColumnValueNumberListOptions().filter(f=> gesetzt == undefined || f.value != gesetzt  );
  })



  ngOnInit() {


    const keys1 = Object.keys(DynListOption).filter(key => !isNaN(DynListOption[key]));
    keys1.forEach(x => this.dynListOptions.push({ label: x, value: DynListOption[x] }));
    this.dynmlistValue = {...this.dynListOptions.find(f => f.value == 1)};

    //nur Möbel Options zur Zeit, keine Auswahl
    this.moebeldynmlistValue = this.dynListOptions.find(f => f.value == DynListOption.MöbeldesSortimentsundModul);

    this.availableColumnToView = this.config.data.availableColumnToView;
    this.allColumns = this.config.data.allColumns;
    this.referenceColumnValueNumberListOptions.set(this.allColumns.filter(f=> f.colName != this.availableColumnToView.colName
      && f.dbMapping
      && (f.colType == ColumnTypes.Number
        || f.colType == ColumnTypes.CheckBox
        || f.colType == ColumnTypes.Text
        || f.colType == ColumnTypes.DynamicList )
     ).map(x => <ItemValueModel>{ label: x.colName, value: x.dbMapping }));


     this.referenceColumnValuesDynListOptions.set(this.allColumns.filter(f=> f.colName != this.availableColumnToView.colName
      && f.dbMapping
      && (f.colType == ColumnTypes.Number
        || f.colType == ColumnTypes.CheckBox
        || f.colType == ColumnTypes.Text
        || f.colType == ColumnTypes.DynamicList )
     ).map(x => <ItemValueModel>{ label: x.colName, value: x.dbMapping }));

    if (this.availableColumnToView.colType == ColumnTypes.List)
      {
        this.store.dispatch(new GetStaticListValuesAction({columnlistid:  this.availableColumnToView.id, listtabletype: ItemValueListTypeTable.AVAILABLECOLUMNS }));
      }



      switch (this.availableColumnToView.colType) {

        case (ColumnTypes.EAN):
          this.eanValue = <EANValue> { value: null }
          break;

        case (ColumnTypes.Text):

          this.textValue.maxlength = this.availableColumnToView.maxLength;
          this.textValue.minlength = this.availableColumnToView.minLength ?? 0;
          this.textValue.validregex = this.availableColumnToView.validRegEx;
          this.textValue.requiredcolumnvalue = this.availableColumnToView.requiredColumnValue;
          this.textValue.notcolumnvalue = this.availableColumnToView.notColumnValue?.split(";");


          break;
        case (ColumnTypes.DateRange):
          this.dateRangeValue = <DateRangeValue>  { daterangestart: new Date, daterangeend: new Date };
          break;
        case (ColumnTypes.NumberRange):
          this.numberRangeValue = <NumberRangeValue> { numberrangestart: 0, numberrangeend: 0 };

          break;
        case (ColumnTypes.List):

          this.selectStaticUsedlistValues$.subscribe(data => {
            if (data && data[this.availableColumnToView.id]) {
              this.listValue.valuelist = data[this.availableColumnToView.id].map(x => <any>{item:  x.value }) ;;
            }
          })
          break;
        case (ColumnTypes.Number):


          this.numberValue.isnumberonly = this.availableColumnToView.isNumberOnly == 1;
          this.numberValue.maxdigits = this.availableColumnToView.maxDigits;
          this.numberValue.maxdecimals = this.availableColumnToView.maxDecimals;
          this.numberValue.requiredcolumnvalue = this.availableColumnToView.requiredColumnValue;
          this.numberValue.notcolumnvalue = this.availableColumnToView.notColumnValue?.split(";");
          this.numberValue.minNumber = this.availableColumnToView.minNumber;
          this.numberValue.maxNumber = this.availableColumnToView.maxNumber;

          break;
        case (ColumnTypes.CheckBox):


          this.checkBoxValue = <BoolValue> { value: null };
          this.checkBoxValue.requiredcolumnvalue = this.availableColumnToView.requiredColumnValue;
          this.checkBoxValue.notcolumnvalue = this.availableColumnToView.notColumnValue?.split(";");

          break;
        case (ColumnTypes.Date):
          this.dateValue = <DateValue>  { value: null };
          break;
          case (ColumnTypes.DynamicList):
          this.dynmlistValue = {...this.dynListOptions.find(f => f.value == this.availableColumnToView.listOptions)};
          this.referenceColumnValueDynList = this.availableColumnToView.requiredColumnValue;
          this.referenceNOTColumnValueDynList = this.availableColumnToView.notColumnValue?.split(";");
          break;


    }


    const keys = Object.keys(ColumnTypes).filter(key => !isNaN(ColumnTypes[key]));
    keys.forEach(x => this.colTypeOptions.push({ label: x, value: ColumnTypes[x] }));
    this.colEnum = ColumnTypes;





    this.store.dispatch(new GetSettingsStateAction({ settingid:  SettingValueEnum.DBMapping, onlyActive: true }));

    this.commondataService.selectSettingValues.pipe(filter(f => f && f.length > 0), take(1)).subscribe(d => {
      if (this.availableColumnToView.dbMapping && !d.find(f => f.settingValue == this.availableColumnToView.dbMapping)) {
        d = this.validateService.getClone(d);
        const current = <ISettingValue>{ id: 0, setting_Id: SettingValueEnum.DBMapping, settingValue: this.availableColumnToView.dbMapping, isActive: 0 };
        d.unshift(current);

      }

      this.settingValueList.set(d);
      this.selecteddbMapping.set(d.find(f => f.settingValue == this.availableColumnToView.dbMapping));
      if (this.selecteddbMapping()) {
        this.changeDbMapping({ value: this.selecteddbMapping(), originalEvent: null }, true);
      }

    }
    )


  }

  changeListenTyp(e)
  {
    if ( e.value == ColumnTypes.DynamicList) {
      this.dynmlistValue = this.moebeldynmlistValue;
    } else
    {
      this.dynmlistValue = null;
    }
  }

  clearDbMapping()
  {
    this.availableColumnToView = this.validateService.getClone(this.availableColumnToView);
    this.availableColumnToView.colType = ColumnTypes.Text;
    this.availableColumnToView.dbMapping  = null;
    this.availableColumnToView.bubMapping = null;
  }



  changeDbMapping(e: SelectChangeEvent, init: boolean = false) {

    if (init == false) {
      this.hint.set(null);
    }
    this.availableColumnToView = this.validateService.getClone(this.availableColumnToView);
    this.availableColumnToView.dbMapping = e.value.settingValue;
    this.availableColumnToView.bubMapping = null;

    if (this.selectedChildren()[e.value.id] == undefined || this.selectedChildren()[e.value.id].length == 0) {
      this.store.dispatch(new GetSettingsChildrenAction({ settingvalueId: e.value.id }));
    }
    let hint = '';
    this.commondataService.selectSettingChildrenValues.subscribe(data => {
      const elements = data[e.value.id];
      if (elements instanceof Array) {
        this.availableColumnToView = this.validateService.getClone(this.availableColumnToView);
        const coltype = elements.find(x => x.name == 'columntype');
        if (coltype && coltype.settingValue) {
          const newtype =  Number(coltype.settingValue) as ColumnTypes;
          if (init && this.availableColumnToView.colType != newtype && init)
          {
            hint += 'Spaltentyp wurde geändert von ' + ColumnTypes[this.availableColumnToView.colType] + ' zu ' + ColumnTypes[newtype];
          }
          this.availableColumnToView.colType = newtype;
        }
        const bub = elements.find(x => x.name == 'bubmapping');
        if (bub && bub.settingValue) {
          if (init && this.availableColumnToView.bubMapping && this.availableColumnToView.bubMapping != bub.settingValue) {
            hint += '\n BubMapping wurde geändert';
          }
          if (this.availableColumnToView.dbMapping == e.value.settingValue )
          {
            this.availableColumnToView.bubMapping = bub.settingValue;
          }
        }
        const desc = elements.find(x => x.name == 'description');
        if (desc && !init) {
          if (!this.availableColumnToView.colDesc || this.availableColumnToView.colDesc.indexOf(desc.settingValue) == -1) {
            this.availableColumnToView.colDesc = desc?.settingValue;
          }
        }
      }
      this.changeListenTyp({ value: this.availableColumnToView.colType });
    })

    if (init == true) {
      this.hint.set(hint);
    }
  }

  clearValidations() {
    this.availableColumnToView.listOptions = 0;
    this.availableColumnToView.maxLength = 0;
    this.availableColumnToView.isNumberOnly = 0;
    this.availableColumnToView.minLength = 0;
    this.availableColumnToView.validRegEx = undefined;
    this.availableColumnToView.maxDigits = 0;
    this.availableColumnToView.maxDecimals = 0;
    this.availableColumnToView.requiredColumnValue = undefined;
    this.availableColumnToView.notColumnValue = undefined;
  }


  canSave()
  {
    return this.availableColumnToView.colName;
  }


  close() {



    switch (this.availableColumnToView.colType) {

      case (ColumnTypes.EAN):

        this.clearValidations();

        break;

      case (ColumnTypes.Text):

        this.clearValidations();
        this.availableColumnToView.maxLength = this.textValue.maxlength && this.textValue.maxlength > 0 ? this.textValue.maxlength :  120;
        this.availableColumnToView.minLength = this.textValue.minlength ? this.textValue.minlength :  0;
        this.availableColumnToView.validRegEx = this.textValue.validregex;
        this.availableColumnToView.requiredColumnValue = this.textValue.requiredcolumnvalue;
        this.availableColumnToView.notColumnValue = this.textValue.notcolumnvalue?.join(";");

        break;
      case (ColumnTypes.DateRange):
        this.clearValidations();
        break;
      case (ColumnTypes.NumberRange):
        this.clearValidations();
        break;
      case (ColumnTypes.List):
        this.clearValidations();

        this.store.dispatch(new UpdateStaticListValuesAction({columnlistid:  this.availableColumnToView.id, items:
          this.listValue.valuelist.map(x => <ItemValueModel> { label:  x.item, value: x.item }), listtabletype:  ItemValueListTypeTable.AVAILABLECOLUMNS }));
        break;
      case (ColumnTypes.Number):

        this.clearValidations();
        this.availableColumnToView.isNumberOnly = this.numberValue.isnumberonly ? 1 : 0;
        this.availableColumnToView.maxDigits = this.numberValue.maxdigits;
        this.availableColumnToView.maxDecimals = this.numberValue.maxdecimals;
        this.availableColumnToView.requiredColumnValue = this.numberValue.requiredcolumnvalue;
        this.availableColumnToView.notColumnValue = this.numberValue.notcolumnvalue?.join(";");
        this.availableColumnToView.minNumber =  this.numberValue.minNumber;
        this.availableColumnToView.maxNumber =  this.numberValue.maxNumber;


        break;
      case (ColumnTypes.CheckBox):

       this.clearValidations();
      this.availableColumnToView.requiredColumnValue = this.checkBoxValue.requiredcolumnvalue;
      this.availableColumnToView.notColumnValue = this.checkBoxValue.notcolumnvalue?.join(";");


        break;
      case (ColumnTypes.Date):
        this.clearValidations();

        break;
        case (ColumnTypes.DynamicList):

          this.clearValidations();
          this.availableColumnToView.requiredColumnValue = this.referenceColumnValueDynList;
          this.availableColumnToView.notColumnValue = this.referenceNOTColumnValueDynList?.join(";");
          this.availableColumnToView.listOptions = this.dynmlistValue.value;


          break;
    }

    this.ref.close(this.availableColumnToView);
  }

  cancel() {
    this.ref.close();
  }

  deleteListValue(itemValue: string) {
    const idx = this.listValue.valuelist.findIndex(x => x.item == itemValue);
    this.listValue.valuelist.splice(idx, 1);
  }

  addNewListValue() {
    this.listValue.valuelist.push({ item: "Neuer Eintrag" });
    this.listValue.valuelist = [...this.listValue.valuelist];
  }
}
